import { objectWithoutProperties as _objectWithoutProperties, taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FlexMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';
import CarouselTab from './CarouselTab.js';
import customPropTypes from '../../utils/custom-prop-types.js';
import { ARROW_COLUMN_WIDTH } from './CarouselNavigation.js';

var _excluded = ["privateRenderType"];
var _templateObject;
var SlideContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-10wga22-0"
})(["display:flex;flex-direction:column;width:100%;overflow:hidden;", ""], FlexMixin);
var ArrowSpacer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-10wga22-1"
})(["display:flex;flex-shrink:0;width:100%;", ""], function (props) {
  return props.showArrows ? css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n                  padding: 0 ", ";\n              "])), ARROW_COLUMN_WIDTH) : '';
});

/**
 * This is only used to get props and put them onto other elements.
 */
function CarouselItem(_ref) {
  var privateRenderType = _ref.privateRenderType,
    props = _objectWithoutProperties(_ref, _excluded);
  switch (privateRenderType) {
    case 'slide':
      {
        return /*#__PURE__*/React.createElement(ArrowSpacer, {
          showArrows: props.showArrows
        }, /*#__PURE__*/React.createElement(SlideContainer, props));
      }
    case 'tab':
      return /*#__PURE__*/React.createElement(CarouselTab, props, props.tab || 'Tab');
    default:
      return null;
  }
}
CarouselItem.displayName = 'Carousel.Item';
CarouselItem.propTypes = process.env.NODE_ENV !== "production" ? {
  alignItems: customPropTypes.inlineMediaQuery(PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline'])),
  justifyContent: customPropTypes.inlineMediaQuery(PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly', 'initial', 'inherit'])),
  /** If showTabs is true on <Carousel> this is the related text for
   * the tab for this slide. If left undefined it will default to read "Tab".
   */
  tab: PropTypes.string,
  /**
   * This is only set by <Carousel> - dev's should not set this.
   * Dev's should leave this undefined.
   */
  privateRenderType: PropTypes.oneOf(['slide', 'tab']),
  /**
   * If should have padding for arrows.
   */
  showArrows: PropTypes.bool
  /**
   * All other props passed, get passed to the reendered element. Like when
   * "slide" it will send the motion props to the slide.
   */
} : {};

export { CarouselItem as default };
